<template>
  <div :class="wrapperClass">
    <global-header v-if="flag.showHeader" />
    <breadcrumbs v-if="flag.showHeader && flag.showBreadcrumbs" />
    <main-contents>
      <router-view />
    </main-contents>
    <global-footer v-if="flag.showHeader" />
    <fixed-bottom-nav v-if="flag.showHeader" />
    <drawer-menu />
    <ContentsModal />
    <MessagesModal />
    <LoadingsModal />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import GlobalHeader from '@/views/layouts/GlobalHeader.vue';
import MainContents from '@/views/layouts/MainContents.vue';
import GlobalFooter from '@/views/layouts/GlobalFooter.vue';
import DrawerMenu from '@/views/layouts/DrawerMenu.vue';
import FixedBottomNav from '@/views/layouts/FixedBottomNav.vue';
import Breadcrumbs from '@/views/layouts/Breadcrumbs.vue';
import { ContentsModal, MessagesModal, LoadingsModal } from '@/views/components/modal';
import 'vue3-carousel/dist/carousel.css';

export default {
  name: 'App',
  components: {
    GlobalHeader,
    MainContents,
    GlobalFooter,
    DrawerMenu,
    FixedBottomNav,
    Breadcrumbs,
    ContentsModal,
    MessagesModal,
    LoadingsModal,
  },
  data() {
    return {
      flag: {
        showHeader: true,
        showBreadcrumbs: true,
      },
      hideHeader: [
        'login',
        'forgot-password',
        'reset-password',
        'print',
        'OpPrint',
        'TcPrint',
      ],
      hideBreadcrumbs: [
        '/',
        '/teacher/', '/teacher',
        '/counselor/', '/counselor',
        '/operator/', '/operator',
        '/signup/', '/signup',
        '/signup2/', '/signup2',
        '/training/h3ddWNr9U7eD/', '/training/h3ddWNr9U7eD',
        '/lti/',
      ],
    };
  },
  computed: {
    ...mapState(['page', 'user']),
    wrapperClass() {
      if (!this.flag.showHeader) {
        return '';
      }
      if (!this.flag.showBreadcrumbs) {
        return `${this.$style.header}`;
      }
      return `${this.$style.withBreadcrumbs}`;
    },
    isModal() {
      const contents = this.$store.state.modal.contents.modalName !== '';
      const loadings = this.$store.state.modal.loadings.modalName !== '';
      const messages = this.$store.state.modal.messages.modalName !== '';
      return contents || loadings || messages;
    },
  },
  created() {
    // ログインチェック
    this.$store.dispatch('user/login/check');
    // backend共通マスターデータ取得
    this.$store.dispatch('helper/getMaster');
    this.$store.dispatch('helper/getTextDisableStatus');
  },
  watch: {
    $route(to) {
      // メタ情報の仕込み
      if (this.user.email) {
        this.setMetas(to, this.$store);
      } else {
        this.$store.subscribe((mutation) => {
          if (mutation.type === 'user/setUserData') {
            this.setMetas(to, this.$store);
          }
        });
      }
      this.checkFlags();
    },
  },
  methods: {
    setMetas: (route, store) => {
      const meta = {};
      // 個別設定がない場合のデフォルト設定
      const defaults = {
        title: 'Welcome to talk',
        description: '',
      };

      const user = store.state.user;
      let metaTitle = route && route.meta ? route.meta.title : '';
      if (user && user.school.length && user.school[0].is_company && metaTitle) {
        if (metaTitle.includes('学校だより')) {
          metaTitle = metaTitle.replace(/学校だより/g, '企業レター');
        } else if (metaTitle.includes('学校')) {
          metaTitle = metaTitle.replace(/学校/g, '企業');
        } else if (metaTitle.includes('教育機関')) {
          metaTitle = metaTitle.replace(/教育機関/g, '導入企業');
        }
      }

      meta.name = route.name;
      meta.title = metaTitle ? `${metaTitle} | ${defaults.title}` : defaults.title;
      meta.description = route.meta.description || defaults.description;

      // meta sets
      document.title = meta.title;
      document.querySelector("meta[name='description']").setAttribute('content', meta.description);

      // store.pageに保持させる
      store.dispatch('page/setPageInfo', meta);
      store.dispatch('page/breadcrumbs/setBreadCrumbs', { meta, route, isCompany: user.school.length && user.school[0].is_company ? 1 : 0 });
    },
    checkFlags() {
      this.flag.showHeader = true;
      this.flag.showBreadcrumbs = true;

      // meta.hideLayoutがtrueの場合はヘッダー・フッターを非表示
      if (this.$route.meta && this.$route.meta.hideLayout) {
        this.flag.showHeader = false;
        this.flag.showBreadcrumbs = false;
        return;
      }

      this.hideHeader.forEach((name) => {
        if (this.$route.path.includes(name)) {
          this.flag.showHeader = false;
        }
        if (this.hideBreadcrumbs.includes(this.$route.path)) {
          this.flag.showBreadcrumbs = false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
// サイト全体のreset style
@import '@/assets/styles/reset.scss';

// CSS変数の定義ファイル
@import '@/assets/styles/variables.scss';

// fontawesome
@import '@/assets/styles/fonts.scss';

// vcalendarのスタイルパッチ
@import '@/assets/styles/patch/vcalendar.scss';

// notosansフォント指定
body {
  font-family: $notosansFont;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media print {
  body, html {
    margin: 0;
    padding: 0;
    height: auto;
  }
  body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  a[href]:after {
    content: "" !important;
  }
  abbr[title]:after {
    content: "" !important;
  }
  @page {
    size: A4 portrait;
    margin: 0mm 10mm;
  }
  .a4-page {
    // width: 210mm;
    // height: 297mm;
    width: 190mm;
    height: 290mm;
    overflow: hidden;
    box-sizing: border-box;
    &.breakAfter:not(:last-child) {
      page-break-after: always; // 複数ページ印刷用
    }
  }
}
</style>

<style lang="scss" module>
.header {
  padding-top: var(--header-height);
}
.withBreadcrumbs {
  padding-top: calc(var(--header-height) + var(--breadcrumbs-height));
}
</style>


<style lang="scss">
.n2br {
  > * {
    white-space: pre-wrap;
    word-break: break-all;
  }
}
// 改行(\n)込みの自由文表示エリア用ユーティリティ。改行保持＋長語/長URL折返し。
// .n2br > * と違い「要素自身」に付与するため、直下 text node にも子要素にも効く。
.multilineText {
  white-space: pre-wrap;   // \n を改行描画（collapse 防止）
  word-break: break-all;   // 長い連続文字をカード幅で折返す
  overflow-wrap: anywhere; // 長URL等の突き抜け防止
}
@-moz-document url-prefix() {
  // firefox向け
  .n2br {
    > * {
      word-wrap: break-word;
    }
  }
}

input, textarea {
  font-size: 16px;
}
// Firefox は単行 input にも resize を honor しリサイズハンドルを表示する（Chrome は無視）。
// resize は textarea のみに限定し、全 input のリサイズハンドルを抑止する。
textarea {
  resize: vertical;
}

.disabled {
  opacity: .5;
  pointer-events: none;
  transition: .4s opacity;
}

html {
  scroll-behavior: smooth;
}

a {
  word-break: break-all;
}

::placeholder{
  color:#bbb;
  text-align: left;
}

.carousel__prev, .carousel__next {
  $size: 3em;
  width: $size;
  color: gray;
  background-color: transparent;
  top: 45%;
  .carousel__icon {
    width: $size;
    height: $size;
    transition: all .4s;
    &:hover {
      opacity: .6;
    }
  }
  @include sm-view {
    $size: 2em;
    width: $size;
    .carousel__icon {
      width: $size;
      height: $size;
    }
  }
}
.carousel__pagination-button {
  margin: var(--vc-pgn-margin);
  padding: 3px;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  background-color: silver;
}
.carousel__pagination-button {
  background-color: silver;
}
.carousel__pagination-button--active {
  background-color: #333333;
}
.carousel__slide {
  img {
    cursor: pointer;
    transition: all .4s;
    &:hover {
      opacity: .8;
    }
  }
}
</style>
